// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "wrapper-BeFqJ";
var _5 = "wrapper__auth-3w5fN";
var _6 = "wrapper__auth_offset-2gkqv";
var _7 = "wrapper__title-3Y8b5";
var _8 = "social-3RYqg";
var _9 = "social__icon-3Kmej";
var _a = "social__name-3Y5i4";
var _b = "social__info-1_oWC";
var _c = "social__user-3_mmQ";
var _d = "social__delete-2u0Zo";
var _e = "login-2cFvu";
var _f = "login__subtitle-1DYIt";
var _10 = "login__auth-a8Gwd";
var _11 = "login__auth_button-1fwLH";
var _12 = "startIcon-2GitW";
var _13 = "login__auth_button__sberid-nBUpa";
var _14 = "login__auth_button__google-1SU5P";
var _15 = "login__auth_button__facebook-2_aUL";
var _16 = "login__auth_button__vkontakte-AsLtU";
var _17 = "login__auth_button__tinkoffid-2E80p";
var _18 = "login__auth_button__alfaid-2UbZ2";
var _19 = "login__auth_button__telegram-3vHhe";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "wrapper", _5 as "wrapper__auth", _6 as "wrapper__auth_offset", _7 as "wrapper__title", _8 as "social", _9 as "social__icon", _a as "social__name", _b as "social__info", _c as "social__user", _d as "social__delete", _e as "login", _f as "login__subtitle", _10 as "login__auth", _11 as "login__auth_button", _12 as "startIcon", _13 as "login__auth_button__sberid", _14 as "login__auth_button__google", _15 as "login__auth_button__facebook", _16 as "login__auth_button__vkontakte", _17 as "login__auth_button__tinkoffid", _18 as "login__auth_button__alfaid", _19 as "login__auth_button__telegram" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "wrapper": _4, "wrapper__auth": _5, "wrapper__auth_offset": _6, "wrapper__title": _7, "social": _8, "social__icon": _9, "social__name": _a, "social__info": _b, "social__user": _c, "social__delete": _d, "login": _e, "login__subtitle": _f, "login__auth": _10, "login__auth_button": _11, "startIcon": _12, "login__auth_button__sberid": _13, "login__auth_button__google": _14, "login__auth_button__facebook": _15, "login__auth_button__vkontakte": _16, "login__auth_button__tinkoffid": _17, "login__auth_button__alfaid": _18, "login__auth_button__telegram": _19 }
